import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from "uuid";
import initialState from './initialState';

import ReactGA from "react-ga4";


export const offlineSlice = createSlice({
  name: 'offline',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setServiceWorkerInitialized: (state, action) => {
      state.serviceWorkerInitialized = true;
    },
    updateServiceWorker: (state, action) => {
      state.latestServiceWorkerLoaded = false
      state.serviceWorkerUpdated = true;
      state.serviceWorkerRegistration = action.payload;
    },
    setLatestServiceWorkerLoaded: (state, action) => {
      state.latestServiceWorkerLoaded = action.payload;
    }
    
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
  },
});

export const { updateServiceWorker, setServiceWorkerInitialized, setLatestServiceWorkerLoaded} = offlineSlice.actions;

export const selectServiceWorkerUpdated = (state) => state.offline.serviceWorkerUpdated;

export const selectServiceWorkerInitialized = (state) => state.offline.serviceWorkerInitialized;

export const selectServiceWorkerRegistration = (state) => state.offline.serviceWorkerRegistration;

export const selectLatestServiceWorkerLoaded = (state) => state.offline.latestServiceWorkerLoaded;


export default offlineSlice.reducer;
